import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import CustomDateTimePicker from "../../../utils/CustomDateTimePicker/CustomDateTimePicker";
import { recruitmentAdminContext } from "../../../context/Admin/RecruitmentAdminContext/RecruitmentAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import {
  convertDate,
  finalResultItems,
  preliminaryResultItems,
  referralSourceItems,
} from "../../../utils";
import Animations from "../../../utils/Animations";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";

const RecruitmentAdmin = () => {
  const permission = useSelector((state) => state.permission);
  const appConfigs = useSelector((state) => state.appConfigs);

  const {
    categories,
    recruitmentItems,
    recruitment,
    id,
    expertiseSearch,
    setExpertiseSearch,
    services,
    setServices,
    referral_source,
    setReferral_source,
    final_result,
    setFinal_result,
    preliminary_result,
    setPreliminary_result,
    attendance_date,
    setAttendance_date,
    referral_source_search,
    setReferral_source_search,
    final_result_search,
    setFinal_result_search,
    preliminary_result_search,
    setPreliminary_result_search,
    recruitment_date,
    setRecruitment_date,
    mobile,
    setMobile,
    first_name,
    setFirst_name,
    last_name,
    setLast_name,
    expertise,
    setExpertise,
    appearance,
    setAppearance,
    education,
    setEducation,
    speech_style,
    setSpeech_style,
    impression,
    setImpression,
    description,
    setDescription,
    search,
    setSearch,
    sort_by,
    setSort_by,
    appearance_search,
    setAppearance_search,
    education_search,
    setEducation_search,
    speech_style_search,
    setSpeech_style_search,
    impression_search,
    setImpression_search,
    isShowModal,
    isShowDetailsModal,
    isShowAdvancedSearch,
    setIsShowAdvancedSearch,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetCategories,
    handleGetServices,
    handleGetRecruitmentItemList,
    handleCreateRecruitmentItem,
    handleEditRecruitmentItem,
    handleDeleteRecruitmentItem,
    isSelectExpertise,
  } = useContext(recruitmentAdminContext);

  useEffect(() => {
    handleGetRecruitmentItemList();
  }, [
    pageNumber,
    limit,
    sort_by,
    referral_source_search,
    final_result_search,
    preliminary_result_search,
    appearance_search,
    education_search,
    speech_style_search,
    impression_search,
  ]);

  useEffect(() => {
    handleGetCategories();
  }, []);

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created" },
        { title: "صعودی", value: "created" },
      ],
    },
    {
      label: "تاریخ جذب",
      options: [
        { title: "نزولی", value: "-recruitment_date" },
        { title: "صعودی", value: "recruitment_date" },
      ],
    },
    {
      label: "نام",
      options: [
        { title: "نزولی", value: "-first_name" },
        { title: "صعودی", value: "first_name" },
      ],
    },
    {
      label: "نام خانوادگی",
      options: [
        { title: "نزولی", value: "-last_name" },
        { title: "صعودی", value: "last_name" },
      ],
    },
    {
      label: "موبایل",
      options: [
        { title: "نزولی", value: "-mobile" },
        { title: "صعودی", value: "mobile" },
      ],
    },
  ];

  return (
    <>
      <SiteTitle title="آیتم های جذب نیرو" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "آیتم های جذب نیرو", type: "a" },
        ]}
        title="لیست آیتم های جذب نیرو"
      />

      <CardLayout>
        {permission.recruitment_create && (
          <div className="mb-2">
            <button
              onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
              className={`btn btn-${
                isShowAdvancedSearch ? "" : "outline-"
              }primary mr-2`}
            >
              جستجو پیشرفته
            </button>
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        <form
          className="input-group mb-3"
          onSubmit={handleGetRecruitmentItemList}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isShowAdvancedSearch && (
          <Animations name="fadeIn">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="referral_source"
                  onChange={(e) => setAppearance_search(e.target.value)}
                >
                  <option selected value="">
                    وضعیت ظاهری: همه
                  </option>
                  <option selected={"true" === appearance_search} value="true">
                    مثبت
                  </option>
                  <option
                    selected={"false" === appearance_search}
                    value="false"
                  >
                    منفی
                  </option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="referral_source"
                  onChange={(e) => setEducation_search(e.target.value)}
                >
                  <option selected value="">
                    میزان سواد: همه
                  </option>
                  <option selected={"true" === education_search} value="true">
                    مثبت
                  </option>
                  <option selected={"false" === education_search} value="false">
                    منفی
                  </option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="referral_source"
                  onChange={(e) => setSpeech_style_search(e.target.value)}
                >
                  <option selected value="">
                    نحوه صحبت: همه
                  </option>
                  <option
                    selected={"true" === speech_style_search}
                    value="true"
                  >
                    مثبت
                  </option>
                  <option
                    selected={"false" === speech_style_search}
                    value="false"
                  >
                    منفی
                  </option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="referral_source"
                  onChange={(e) => setImpression_search(e.target.value)}
                >
                  <option selected value="">
                    نظر مسئول: همه
                  </option>
                  <option selected={"true" === impression_search} value="true">
                    مثبت
                  </option>
                  <option
                    selected={"false" === impression_search}
                    value="false"
                  >
                    منفی
                  </option>
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="referral_source"
                  onChange={(e) =>
                    setReferral_source_search(
                      e.target.value ? Number(e.target.value) : null
                    )
                  }
                >
                  <option selected value="">
                    نحوه آشنایی: همه
                  </option>
                  {referralSourceItems?.map((_value, index) => (
                    <option
                      key={index + 1}
                      selected={index + 1 === referral_source_search}
                      value={index + 1}
                    >
                      {_value}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="preliminary_result"
                  onChange={(e) =>
                    setPreliminary_result_search(
                      e.target.value ? Number(e.target.value) : null
                    )
                  }
                >
                  <option selected value="">
                    وضعیت تماس اولیه: همه
                  </option>
                  {preliminaryResultItems?.map((_value, index) => (
                    <option
                      key={index + 1}
                      selected={index + 1 === preliminary_result_search}
                      value={index + 1}
                    >
                      {_value}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <select
                  className="form-control"
                  name="final_result"
                  onChange={(e) =>
                    setFinal_result_search(
                      e.target.value ? Number(e.target.value) : null
                    )
                  }
                >
                  <option selected value="">
                    نتیجه نهایی: همه
                  </option>
                  {finalResultItems?.map((_value, index) => (
                    <option
                      key={index + 1}
                      selected={index + 1 === final_result_search}
                      value={index + 1}
                    >
                      {_value}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="مرتب سازی بر اساس">
                  <select
                    className="form-control"
                    value={sort_by}
                    onChange={(e) => setSort_by(e.target.value)}
                  >
                    {sortByOptions.map((_item, index) => (
                      <optgroup label={_item.label} key={index}>
                        {_item.options?.map((option) => (
                          <option
                            key={option.value}
                            selected={sort_by === option.value}
                            value={option.value}
                          >
                            {option.title}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
            </div>
          </Animations>
        )}
        {isEmpty(recruitmentItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th>زمان اولیه پیگیری</th>
                  <th>تاریخ جذب</th>
                  <th>نحوه آشنایی</th>
                  <th>وضعیت تماس اولیه</th>
                  <th>نتیجه نهایی</th>
                  <th>حالت</th>
                  <th>ظاهر</th>
                  <th>سواد</th>
                  <th>نحوه صحبت</th>
                  <th>نظر مسئول</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {recruitmentItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{_item?.user?.first_name}</td>
                    <td>{_item?.user?.last_name}</td>
                    <td>{_item?.user?.mobile}</td>
                    <td>{convertDate(_item?.attendance_date)}</td>
                    <td>{convertDate(_item?.recruitment_date)}</td>
                    <td>
                      {referralSourceItems?.[_item?.referral_source - 1] || "-"}
                    </td>
                    <td>
                      {preliminaryResultItems?.[
                        _item?.preliminary_result - 1
                      ] || "-"}
                    </td>
                    <td>
                      {finalResultItems?.[_item?.final_result - 1] || "-"}
                    </td>
                    <td>
                      <i
                        className={`fa ${
                          _item?.referral_source
                            ? "fa-check text-success"
                            : "fa-times text-danger"
                        }`}
                      />
                    </td>
                    <td>
                      <i
                        className={`fa ${
                          _item?.appearance
                            ? "fa-check text-success"
                            : "fa-times text-danger"
                        }`}
                      />
                    </td>
                    <td>
                      <i
                        className={`fa ${
                          _item?.education
                            ? "fa-check text-success"
                            : "fa-times text-danger"
                        }`}
                      />
                    </td>
                    <td>
                      <i
                        className={`fa ${
                          _item?.speech_style
                            ? "fa-check text-success"
                            : "fa-times text-danger"
                        }`}
                      />
                    </td>
                    <td>
                      <i
                        className={`fa ${
                          _item?.impression
                            ? "fa-plus text-success"
                            : "fa-minus text-danger"
                        }`}
                      />
                    </td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.recruitment_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.recruitment_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteRecruitmentItem(_item.id),
                              `آیا از حذف آیتم جذب نیرو ${_item.id} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} آیتم جذب نیرو`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="lg"
      >
        <form
          onSubmit={
            id ? handleEditRecruitmentItem : handleCreateRecruitmentItem
          }
          autoComplete="off"
        >
          <div className="row">
            {!id && (
              <>
                <div className="col-12 col-md-6 col-lg-4 mb-2">
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="form-control"
                    placeholder="نام"
                    value={first_name}
                    onChange={(e) => setFirst_name(e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4 mb-2">
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="form-control"
                    placeholder="نام خانوادگی"
                    value={last_name}
                    onChange={(e) => setLast_name(e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-4 mb-2">
                  <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    className="form-control"
                    placeholder="شماره تماس"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div className="col-12 mb-3" />
              </>
            )}
            <div className="col-12 col-md-6 col-lg-4 mb-2">
              <select
                className="form-control"
                name="referral_source"
                onChange={(e) =>
                  setReferral_source(
                    e.target.value ? Number(e.target.value) : null
                  )
                }
              >
                <option selected value="" disabled hidden>
                  نحوه آشنایی
                </option>
                {referralSourceItems?.map((_value, index) => (
                  <option
                    key={index + 1}
                    selected={index + 1 === referral_source}
                    value={index + 1}
                  >
                    {_value}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-2">
              <select
                className="form-control"
                name="preliminary_result"
                onChange={(e) =>
                  setPreliminary_result(
                    e.target.value ? Number(e.target.value) : null
                  )
                }
              >
                <option selected value="" disabled hidden>
                  وضعیت تماس اولیه
                </option>
                {preliminaryResultItems?.map((_value, index) => (
                  <option
                    key={index + 1}
                    selected={index + 1 === preliminary_result}
                    value={index + 1}
                  >
                    {_value}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-2">
              <select
                className="form-control"
                name="final_result"
                onChange={(e) =>
                  setFinal_result(
                    e.target.value ? Number(e.target.value) : null
                  )
                }
              >
                <option selected value="" disabled hidden>
                  نتیجه نهایی
                </option>
                {finalResultItems?.map((_value, index) => (
                  <option
                    key={index + 1}
                    selected={index + 1 === final_result}
                    value={index + 1}
                  >
                    {_value}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 mb-3" />
            <div className="col-12 col-md-6 col-lg-3 mb-2 d-flex  align-items-center">
              <label className="mr-3">وضعیت ظاهری</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={appearance}
                  id="appearance"
                  onClick={(e) => setAppearance(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-2 d-flex  align-items-center">
              <label className="mr-3">میزان سواد</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={education}
                  id="education"
                  onClick={(e) => setEducation(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-2 d-flex  align-items-center">
              <label className="mr-3">نحوه صحبت</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={speech_style}
                  id="speech_style"
                  onClick={(e) => setSpeech_style(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="col-12 col-md-12 col-lg-3 mb-2 d-flex  align-items-center">
              <label className="mr-3">نظر مسئول</label>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={impression}
                  id="impression"
                  onClick={(e) => setImpression(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <div className="col-12 mb-3" />
            <div className="col-12 col-md-6 mb-2">
              <CustomDateTimePicker
                placeholder="زمان اولیه پیگیری را انتخاب کنید"
                onChange={setAttendance_date}
                initValue={attendance_date}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <CustomDateTimePicker
                placeholder="تاریخ جذب را انتخاب کنید"
                onChange={setRecruitment_date}
                initValue={recruitment_date}
              />
            </div>

            <div className="col-12 mb-3" />
            <div className="col-12 mb-2">
              <textarea
                id="description"
                name="description"
                className="form-control"
                placeholder="توضیحات"
                value={description}
                rows={3}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          {isEmpty(services) ? (
            <div className="row justify-content-center mx-0">
              {categories?.map((_item, index) => (
                <div className="col-auto my-2 px-1" key={index}>
                  <span
                    className="cursorPointer"
                    onClick={() => handleGetServices(_item?.id)}
                  >
                    <img
                      key={_item?.id}
                      src={`${appConfigs.APP_DOWNLOAD_LINK}static/console/${_item.icon}.png`}
                      alt={_item.name}
                      width="130"
                      height="130"
                    />
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="mb-3">
                <input
                  type="text"
                  placeholder="جستجو بر اساس نام در تخصص ها"
                  value={expertiseSearch}
                  onChange={(e) => {
                    !e.target.value.includes(`\\`) &&
                      setExpertiseSearch(e.target.value);
                  }}
                  className="form-control"
                />
              </div>
              <div className="mb-2 text-left">
                <button
                  className="btn btn-light"
                  onClick={() => {
                    setServices([]);
                    setExpertiseSearch("");
                  }}
                >
                  <i className="fa fa-arrow-right" /> بازگشت
                </button>
              </div>

              <div className="row">
                {services
                  ?.filter((s) =>
                    s?.name?.toLowerCase().match(expertiseSearch?.toLowerCase())
                  )
                  ?.map((service) => (
                    <div className="col-6 col-md-4 mb-2" key={service.id}>
                      <button
                        type="button"
                        className={`btn btn${
                          isSelectExpertise(service.id) ? "" : "-outline"
                        }-primary btn-block`}
                        onClick={() => {
                          isSelectExpertise(service.id)
                            ? setExpertise(
                                expertise.filter((e) => e !== service.id)
                              )
                            : setExpertise([...expertise, service.id]);
                        }}
                      >
                        {service.name}
                      </button>
                    </div>
                  ))}
              </div>
            </>
          )}

          <button
            className={`btn btn-${id ? "primary" : "success"} btn-block`}
            type="submit"
          >
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم جذب نیرو"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{recruitment.id}</p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default RecruitmentAdmin;
